/** @format */

import React from "react";
import starsImg from "../../assets/stars.png";

type CardInfo = {
  title: string;
  summary: string;
  icon: string;
  flex?: boolean;
  color?: string;
  stars?: boolean;
  fontWeight?: string;
  alignItems?: "items-center" | "items-start" | "items-end";
} & typeof defaultProps;

const defaultProps = {
  color: "text-black",
  flex: false,
  stars: false,
  alignItems: "items-center",
  fontWeight: "font-semibold",
};

const Card = ({
  title,
  summary,
  icon,
  flex,
  color,
  stars,
  alignItems,
  fontWeight,
}: CardInfo) => {
  return (
    <div
      className={
        flex
          ? `flex flex-row space-x-6 ${alignItems}`
          : "flex flex-col space-y-6 items-center text-center"
      }
    >
      <img src={icon} alt={title} className="w-[60px] h-[60px] rounded-full" />
      <div>
        <h2
          className={`${fontWeight} text-[20px] mb-[8px] leading-[27px] tracking-[-0.02em] ${color}`}
        >
          {title}
        </h2>
        {stars && <img className="mb-[12px]" src={starsImg} alt="stars" />}
        <p
          className={`text-[18px] font-normal leading-[25px] tracking-[-0.02em] ${color}`}
        >
          {summary}
        </p>
      </div>
    </div>
  );
};

Card.defaultProps = defaultProps;

export default Card;
